
      import OneToOne from './one-to-one.vue'
      import type { App, Plugin } from 'vue'

      export const OneToOnePlugin: Plugin = {
        install(app: App) {
          app.component('OneToOne', OneToOne)
        },
      }
      export { OneToOne }
      